<template>
	<div>
		<div v-if="loading" class="row">
			<div class="col-md-12">
				<spinner></spinner>
			</div>
		</div>

		<div v-else class="row">
			<div class="col-md-10">
				<div :class=" 'product_title bg_'+ getRouteLineName()">{{ items.sct_name }}</div>
			</div>
			<div class="col-md-2">
				<router-link :to=" { name: 'category', params: { language: getLocale, ctg: getCategory  } } " :class=" 'btn-back text-center bg_'+ getRouteLineName()" exact><i class="fa fa-chevron-left mr-2"></i>{{ $t('Volver') }}</router-link>
			</div>

    	<div v-for=" (item, index) in items.types " :key="index" class="col-xl-4 col-lg-6 col-md-6 mt-20">
        <router-link :to="{ name: 'type', params: { language: getLocale, lin: getRouteParams.lin, ctg: getRouteParams.ctg, sct: getRouteParams.sct, typ: setUrlParams(item.typ_id,item.typ_name)  } }">
					<figure class="featured_category">
						<div class="imagen" :style=" 'background: url('+getBaseUrl+getImgUrl+item.typ_image+');'"></div>
						<span :class=" getRouteLineName() ">{{ item.typ_name }}</span>
					</figure>
				</router-link>
      </div>
		</div>

		<!-- <pre>
			{{ items }}
		</pre> -->

	</div>
</template>

<i18n>
	{
		"es": {
			"Error": "Error",
			"Volver": "Volver"
		},
		"en": {
			"Error": "Error",
			"Volver": "Go Back"
		}
	}
</i18n>

<script>
	import Spinner from './helpers/Spinner.vue';

	import { mapGetters, mapMutations } from 'vuex';
	import { mixinGlobal } from './../mixins/mixinGlobal';

  export default {
    mixins: [ mixinGlobal ],
		components: { Spinner },
	  data () {
	    return {
	      loading: false,
	      items: [],
	    }
	  },
	  mounted(){
      this.loadData();
    },
    computed: {	
      ...mapGetters( ['getLocale', 'getApiUrl', 'getBaseUrl', 'getRouteParams', 'getImgUrl', 'getCategory'] ),		
    },
    methods: {
			...mapMutations(['mutateGlobalMessage']),
      loadData(){
      	let lineId = this.getRouteLineId();
      	let categoryId = this.getRouteCategoryId();
      	let subcategoryId = this.getRouteSubcategoryId();

        this.startLoading();

        this.$axios.get(this.getApiUrl + 'productos.php?lin=' + lineId + '&sct=' + subcategoryId)
        .then( (respuesta) =>{  
          if( this.checkResponseData(respuesta.data) ){
						this.items = respuesta.data.data;
					}else{
						this.$store.commit('mutateGlobalMessage', { toast: false, icon: 'error', title: this.$t('Error'), message: respuesta.data } )
					}  
          this.stopLoading();
        })  
        .catch( (error) =>{ 
					let  message = '';
					if (error.response.data.hasOwnProperty('message')) {
						message = error.response.data.message;
					}else{
						message = error
					}
					this.$store.commit('mutateGlobalMessage', { toast: false, icon: 'error', title: this.$t('Error'), message:   message } )
					this.stopLoading();
        })               
      },      
    },
    watch:{
      $route (to, from){
      	this.loadData();
      }
    }
	}
</script>